import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { indexRowChartPollingAtom } from '../../state';

export type UseIndexRowChartPollingCoordinatorCommonParams = {
  refreshIntervalInMilliseconds: number;
};

export const useIndexRowChartPollingCoordinatorCommon = ({
  refreshIntervalInMilliseconds,
}: UseIndexRowChartPollingCoordinatorCommonParams): void => {
  const setPollingTick = useSetAtom(indexRowChartPollingAtom);

  useEffect(() => {
    const pollingInterval = setInterval(() => {
      setPollingTick(Date.now());
    }, refreshIntervalInMilliseconds);

    return () => {
      clearInterval(pollingInterval);
    };
  }, [refreshIntervalInMilliseconds, setPollingTick]);
};
